module.exports = __webpack_public_path__ + "static/media/View_001.9759c7a1.jpg";